import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "@/shared/ui";

type Props = {
  headerList: string[];
  activeHeaderTab: string;
  setActiveHeaderTab: (item: string) => void;
  className?: string;
};

export default function FactionTabs({
  headerList,
  activeHeaderTab,
  setActiveHeaderTab,
  className,
}: Props) {
  const { t } = useTranslation("faction");

  return (
    <div className={clsx("flex items-center gap-2", className)}>
      {headerList.map((item) => (
        <Button
          key={item}
          variant={activeHeaderTab === item ? "solid-gradient" : "solid"}
          className={clsx(
            "h-9.5 px-4 py-3 bg-white/3 hover:bg-white/5",
            activeHeaderTab !== item && "text-white/55",
          )}
          onClick={() => setActiveHeaderTab(item)}
        >
          {t(`faction.headerTabs.${item}`)}
        </Button>
      ))}
    </div>
  );
}
